'use strict';

angular.module('ntmApp').factory('ListGridActions', ['$routeParams', 'ListGridRowActions', 'ListGridConstants', 'ListGridStatus', 'UserInfo', 'Constants',
    function ($routeParams, ListGridRowActions, ListGridConstants, ListGridStatus, UserInfo, Constants) {

        function ListGridActions(type, callback) {

            var self = this;
            self.rowActions = new ListGridRowActions(type, callback);

            UserInfo.GetUserInfo().then(function (user) {
                self.userData = user;
            });

            self.showAddButton = function (editType, mode) {
                return ListGridStatus.grid.canInsert &&
                    (editType === ListGridConstants.EditType.DIALOG || mode === ListGridConstants.Mode.NONE) &&
                    (self.userData && self.userData.loginType !== Constants.LoginTypes.Cayuse || $routeParams.id !== ListGridConstants.oneLogin.contactsPageID);
            };

            self.showSaveButton = function (editType, mode) {
                return editType === ListGridConstants.EditType.INLINE &&
                    (mode === ListGridConstants.Mode.ADD || mode === ListGridConstants.Mode.EDIT);
            };

            self.showSaveAndAddNewButton = function (editType, mode) {
                return self.showSaveButton(editType, mode) && ListGridStatus.grid.canInsert;
            };

            self.disableAction = function (action, editType, mode) {
                return editType === ListGridConstants.EditType.INLINE && mode !== ListGridConstants.Mode.NONE ||
                    action.showOnSelect && !self.rowActions.selectedRow;
            };
        }

        return (ListGridActions);
    }]);